import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import Adlogo from "../components/Adlogo";

const linkData = [
  {
    content: "My other portfolios",
    url: "https://shresthasuzayn.netlify.app/portfolio",
  },
  {
    content: "My Blogs",
    url: "https://shresthasuzayn.netlify.app/blog",
  },
];
const categoryData1 = [
  {
    content: "Schools",
  },
  {
    content: "Web",
  },
  {
    content: "Coastal",
  },
  {
    content: "SnapGreet",
  },
];
const categoryData2 = [
  {
    content: "React",
  },
  {
    content: "Astro",
  },
  {
    content: "HTML, CSS JS",
  },
  {
    content: "Responsiveness",
  },
];

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Adlogo />
          <div class="footers">
            <div class="container">
              <div class="row">
                <div class="col-md-7">
                  <div class="row">
                    <div class="col-md-6 col-sm-5 col-xs-3">
                      <div class="pb-3">
                        <h3>CORPORATE</h3>
                      </div>
                      <p>Contact Us </p>
                      <div class="position-relative">
                        <form action="">
                          <input
                            type="email"
                            class="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Your email here"
                          />
                        </form>
                        <div class="mail-icon">
                          <i class="fa-solid fa-envelope me-2 text-secondary"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-5 col-xs-3">
                      <div class="pb-3">
                        <h5>NETWORK</h5>
                      </div>
                      <p>Find best digital products</p>
                      <p>
                        <i class="fa-solid fa-phone me-2"></i>
                        +9843779984/9849633111
                      </p>
                      <p>

                        <i class="fa-solid fa-envelope me-2"></i>
                        shresthasujen45@gmail.com{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-5">
                  <div class="row">
                    <div class="col-md-6 col-sm-5 col-xs-3">
                      <div class="pb-3">
                        <h5>More about me</h5>
                      </div>

                      {linkData.map((data) => (
                        <>
                          <p>
                            <a
                              href={data.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {data.content}
                            </a>
                          </p>
                        </>
                      ))}
                    </div>
                    <div class="col-md-6 col-sm-5 col-xs-3">
                      <div class="pb-3">
                        <h5>Categories</h5>
                      </div>

                      <div class="row">
                        <div class="col-md-6 col-sm-5 col-xs-3">
                          {categoryData1.map((data) => (
                            <p>
                              {" "}
                              <a href="#">{data.content}</a>{" "}
                            </p>
                          ))}
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-3">
                          {categoryData2.map((data) => (
                            <p>
                              {" "}
                              <a href="#">{data.content}</a>{" "}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <div className="social-icon">
                <a href="https://www.linkedin.com/in/sujen-shrestha-8b857825a/">
                  <img src={navIcon1} alt="Icon" />
                </a>
                <a href="https://www.facebook.com/">
                  <img src={navIcon2} alt="Icon" />
                </a>
                <a href="https://www.instagram.com/su_zayn_shrestha/">
                  <img src={navIcon3} alt="Icon" />
                </a>
              </div>

              <p>All rights reserved © 2022</p>
            </div>
          </div>
        </Row>
      </Container>
    </footer>
  );
};
